import ApiUrl from "../../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (setValues) => {
    fetch(ApiUrl.LabAdmin_Orders,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        console.log(data)
        setValues(data.response);
    });
}

const GetByStatus = (status,setValues) => {
    fetch(ApiUrl.LabAdmin_Orders+"/bystatus/"+status,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
    });
}

const UpdateStatus = (id,body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Orders+"/orderstatus/"+id,{
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Updated", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            Get(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const UpdateDepartment = (id,body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Orders+"/orderdepartment/"+id,{
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Updated", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            Get(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const GetPaginated = (page, limit, setValues, setPaginationInfo) => {
    fetch(ApiUrl.LabAdmin_Orders+"?page="+page+"&limit="+limit,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
        setPaginationInfo({
            totalPages: data.totalPages || 1,
            currentPage: data.currentPage || 1,
            totalRecords: data.total || 0
        });
    });
}

const GetByStatusPaginated = (status, page, limit, setValues, setPaginationInfo) => {
    fetch(ApiUrl.LabAdmin_Orders+"/bystatus/"+status+"?page="+page+"&limit="+limit,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
        setPaginationInfo({
            totalPages: data.totalPages || 1,
            currentPage: data.currentPage || 1,
            totalRecords: data.total || 0
        });
    });
}

export default {Get,GetByStatus,GetPaginated,GetByStatusPaginated,UpdateDepartment,UpdateStatus};